import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./supabase";
import { ThemeProvider } from "./contexts/ThemeContext";
import DesignApplier from "./components/DesignApplier";
import CustomCodeInjector from "./components/CustomCodeInjector";
import SupportWidget from "./components/SupportWidget";
import NativeShell from "./components/NativeShell";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <AuthProvider>
          <DesignApplier />
          <CustomCodeInjector />
          <BrowserRouter basename={__BASE_PATH__}>
            {/* NativeShell handles Capacitor splash/back/status-bar +
                renders the first-launch onboarding overlay. No-op on web. */}
            <NativeShell />
            <AppRoutes />
            <SupportWidget />
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;
